import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import hydroponics_systems_growslab from "../../Assets/hydroponics_systems_growslab.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav, Carousel } from "react-bootstrap";
import "../../App.css";

const Growslab_shop = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 60,
      name: "Twisted Rope (Tensioning Rope)",
      price: 250,
      image: hydroponics_systems_growslab,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_systems_growslab}
                alt="nft"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Grow Slab System</h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>

            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  Grow Slabs are advanced hydroponic growing media, pre-filled
                  with high-quality cocopeat or rockwool substrate and enclosed
                  in durable, UV-protected plastic sleeves. These slabs offer a
                  clean, efficient, and highly productive medium for growing
                  fruiting vegetables and flowers in polyhouses and greenhouses.
                </p>
                <i>Note: Minimum Order Quantity: 100 Units</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <ul>
                  <li>
                    <span className="fw-bold">Material(Filling):</span> 100%
                    Organic Cocopeat / Coco Chips / Rockwool (as per
                    requirement)
                  </li>
                  <li>
                    <span className="fw-bold">Outer Covering:</span>{" "}
                    UV-stabilized and food-safe LDPE sleeve
                  </li>
                  <li>
                    <span className="fw-bold">Size:</span>1000 mm x 200 mm x 100
                    mm (custom sizes available)
                  </li>
                  <li>
                    <span className="fw-bold">Pre-cut Planting Holes:</span> 2,
                    3, or 4 slots per slab
                  </li>
                  <li>
                    <span className="fw-bold">Drainage Holes:</span>Pre-punched
                    for efficient drainage
                  </li>
                  <li>
                    <span className="fw-bold">pH Level:</span>Neutral to
                    slightly acidic (5.5 to 6.5)
                  </li>
                  <li>
                    <span className="fw-bold">Brand:</span> RGCPL
                  </li>

                  <li>
                    <span className="fw-bold">Minimum Order Quantity:</span> 100
                    slabs
                  </li>
                  <li>
                    <span className="fw-bold">Shelf Life:</span> 3–4 Years
                    (outer layer), 2–3 cycles (substrate)
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Ready to Use: Pre-filled and pre-cut, ideal for direct
                    planting
                  </li>
                  <li>
                    High Aeration: Promotes healthy root development and better
                    oxygenation
                  </li>
                  <li>
                    Reusable Sleeve: Strong outer plastic allows for multiple
                    crop cycles
                  </li>
                  <li>
                    Moisture Retention: Retains sufficient moisture for root
                    zone stability
                  </li>
                  <li>
                    Pest & Disease Free: Clean, controlled media environment
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <ul>
                  <li>
                    <span className="fw-bold">Item Code:</span> RGCPL-0035
                  </li>
                  <li>
                    <span className="fw-bold">Delivery Time:</span> 7-8 Days
                  </li>
                  <li>
                    <span className="fw-bold">Port of Dispatch:</span>{" "}
                    Maharashtra, India
                  </li>
                  <li>
                    <span className="fw-bold">Production Capacity:</span> 1500
                    Slabs Per Day
                  </li>
                  <li>
                    <span className="fw-bold">Packaging Details:</span> Bundled
                    in groups with protective wrap
                  </li>
                  <li>
                    <span className="fw-bold">Payment Terms:</span> Advance
                    Payment
                  </li>
                  <li>
                    <span className="fw-bold">Payment Mode:</span> RTGS / NEFT /
                    IMPS
                  </li>
                </ul>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Importance of Grow Slab System:</h5>
        <p className="text-justify">
          Grow Slabs provide an ideal medium for root development, water
          retention, and nutrient management. They are especially beneficial in
          climates or areas with poor soil quality, allowing for cleaner,
          faster, and higher-yield crop production.
        </p>

        <h5 className="mt-3">Key Benefits of Grow Slab System:</h5>
        <ul>
          <li>Excellent water retention and drainage.</li>
          <li>Pre-filled and easy to install – saves labor time.</li>
          <li>Promotes consistent yields and crop quality.</li>
          <li>Ideal for commercial polyhouse farming.</li>
        </ul>

        <h5 className="mt-3">Applications of Grow Slab System:</h5>
        <ul>
          <li>Growing tomatoes, capsicum, cucumbers, and strawberries.</li>
          <li>Floriculture: Gerbera, Carnation, and Rose cultivation.</li>
          <li>Polyhouses, Greenhouses, and Shade Net Houses.</li>
          <li>Export-oriented vegetable and fruit production.</li>
        </ul>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Growslab_shop;
